// extracted by mini-css-extract-plugin
export default {"container":"KuponForm_container__gQK3E","card":"KuponForm_card__Hsl-w","title":"KuponForm_title__yawRW"};